import React from "react";
import "./styles.css";
import {useTranslation} from "react-i18next";
import logo_full from "../../../assets/img/logo_full.svg"

const Footer = () => {
    const [t] = useTranslation("common");

    return (
        <div className="footerContent">
            <div className="headerContent">
                <div className="header">
                    <div>
                        <img src={logo_full} alt={"logo_full"} />
                    </div>
                    <div>

                    </div>
                </div>
                <div className="mainHeaderContent">
                    <div className="headerDescription">
                        <div>
                            <p>
                                {t("footer.getLatestNews")}
                            </p>
                        </div>
                        <div>
                            <p>
                                <b>
                                    {t("footer.subscribeTo")}
                                </b>
                            </p>
                        </div>
                    </div>
                    <div className="footerLinksContent">
                        <div className="footerColumn">
                            <h1>
                                {t("footer.products")}
                            </h1>
                            <a>
                                {t("footer.splendos")}
                            </a>
                            <a>
                                {t("footer.splendosGrid")}
                            </a>
                            <a>
                                {t("footer.splendosMoblile")}
                            </a>
                        </div>
                        <div className="footerColumn">
                            <h1>
                                {t("footer.help")}
                            </h1>
                            <a>
                                {t("footer.howToInstallSplendos")}
                            </a>
                            <a>
                                {t("footer.systemRequirements")}
                            </a>
                            <a>
                                {t("footer.switchYourOrganization")}
                            </a>
                            <a>
                                {t("footer.otherHelpArticles")}
                            </a>
                        </div>
                        <div className="footerColumn">
                            <h1>
                                {t("footer.company")}
                            </h1>
                            <a>
                                {t("footer.about")}
                            </a>
                            <a>
                                {t("footer.blog")}
                            </a>
                            <a>
                                {t("footer.pressKit")}
                            </a>
                            <a>
                                {t("footer.donate")}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="allRightsReserved">
                <p><b>{t("footer.allRightsReserved1")}</b>{t("footer.allRightsReserved2")}</p>
                <p>{t("footer.anyTrademarks")}</p>
                <div className="links">
                    <a>{t("footer.termsOfService")}</a>
                    <a>{t("footer.privacyPolicy")}</a>
                    <a>{t("footer.cookiesPolicy")}</a>
                </div>
            </div>
        </div>
    );
}

export default Footer;
